import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { axiosInstance } from '../lib/axio';
import '../styles/blogList.css'

const BlogList = () => {
  const blogIds = useRef(new Set());
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    const firstBlog = async () => {
      try {
        const response = await axiosInstance('blogs/firstBlog', {});
        if(blogIds.current.has(response.data.blog._id)) return;
        setPosts((prevPosts) => [...prevPosts, response.data.blog]);
        blogIds.current.add(response.data.blog._id)
        console.log(response.data.blog)
      } catch (error) {
        console.log(error)
      }

    }
    firstBlog();
  }, [])



  // Use a Set to track unique blog IDs

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(`blogs/all-blogs?page=${page}&limit=6`);
        if (response.data.success) {
          const newBlogs = response.data.blogs.filter(blog => !blogIds.current.has(blog._id));

          // Add the IDs of the new blogs to the Set
          newBlogs.forEach(blog => blogIds.current.add(blog._id));

          // Update state with the new blogs
          setPosts((prevPosts) => [...prevPosts, ...newBlogs]);

          // If the fetched blogs are fewer than the limit, we've reached the end

          setHasMore(response.data.hasMore);

        }
      } catch (error) {
        console.error('Error fetching latest blogs:', error);
      }
      setLoading(false);
    };

    fetchBlogs();
  }, [page]);

  const handleLoadMore = () => {
    if (hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  };

  const getPlainText = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };


  return (
    <div>
      <div className="bg-white py-32 px-4 sm:px-6 lg:px-8 bloglist-container">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-extrabold tracking-tight text-[#f08e80] sm:text-4xl text-center">
            Recent Posts
          </h2>
          <p className="mt-4 text-lg text-gray-500 text-center">
            Discover the latest articles and updates.
          </p>
          <div className="mt-28 grid gap-10 sm:grid-cols-2 lg:grid-cols-3 bloglist-hover-container">
            {posts.map((post) => (
              <div key={post._id} className="group bloglist-hover-blog">
                <Link to={`${post.slug}`}
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                >
                  <div className="overflow-hidden rounded-lg aspect-w-16 aspect-h-9  h-[500px]">
                    <img
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      src={post.imageUrl}
                      alt={post.title}
                    />
                  </div>
                  <div className="mt-4">
                    <p className="text-sm text-gray-500">{formatDate(post.date)}</p>
                    <h3 className="text-lg font-medium text-[#f08e80] mt-2">
                      {post.title}
                    </h3>
                    <p className="text-sm text-black mt-2">{getPlainText(post.content).split(" ").slice(0, 20).join(" ") + "..."}</p>
                    <span
                      className="text-[#f08e80] font-medium hover:underline mt-2 inline-block"
                    >
                      Read More
                    </span>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          {loading && <p>Loading...</p>}

          {hasMore && !loading && (
            <button
              onClick={handleLoadMore}
              className="mt-8 px-6 py-3 text-lg font-semibold text-white bg-[#f08e80] rounded-lg hover:bg-[#e56b53] transition-all"
            >
              Show More
            </button>
          )}

          {/* {!hasMore && !loading && (
            <p className="mt-8 text-center text-gray-500">No more blogs to show.</p>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default BlogList;
